module.exports = __webpack_public_path__ + "static/Grazielle-3d5aaff49f3db7636583b59d327ee3d1.jpg";